<template>
  <div id="OrderPage" class="pb-8 animate-page">
    <min-nav></min-nav>
    <page-header title="الطلبات" icon="fas fa-clipboard-list"></page-header>

    <!-- ── Change Status Modal ── -->
    <div v-if="chackOwner || this.getUserRole == 'admin'"
         :class="[changeStatusInit ? 'active' : '', 'edit-form']">
      <div class="bg-white rounded-2xl p-6 w-full max-w-sm" style="box-shadow:0 25px 60px -15px rgba(0,0,0,.22); animation: scaleIn .35s cubic-bezier(.16,1,.3,1) both;">
        <div class="flex items-center justify-between mb-5">
          <h3 class="font-bold text-dark-2 text-lg flex items-center gap-2">
            <span class="w-8 h-8 rounded-lg flex items-center justify-center text-sm" style="background:rgba(16,185,129,.12);color:#10b981;">
              <i class="fas fa-exchange-alt"></i>
            </span>
            نقل إلى قسم
          </h3>
          <button @click.prevent="changeStatusInit = false"
                  class="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-600 duration-200">
            <i class="fas fa-times text-sm"></i>
          </button>
        </div>
        <div class="input mb-5">
          <label class="requier">قسم الفحص</label>
          <select v-model="changeStatusValue.status" class="field">
            <option value="" selected disabled>اختر القسم</option>
            <option value="1">جـــك</option>
            <option value="2">داينو</option>
            <option value="3">فحص البدي</option>
            <option value="6">كمبيوتر</option>
          </select>
        </div>
        <div class="flex justify-end gap-2">
          <button class="btn sub-btn text-sm py-2 px-4" @click.prevent="changeStatusInit = false">إلغاء</button>
          <button :class="[postLoader ? 'opacity-60 cursor-not-allowed' : '', 'btn main-btn text-sm py-2 px-4']"
                  :disabled="postLoader" @click.prevent="changeStatusData()">
            <i class="fas fa-check ml-1"></i> تأكيد
          </button>
        </div>
      </div>
    </div>

    <!-- ── Edit Order Modal ── -->
    <div v-if="(chackOwner||chackAdmin)"
         :class="[editStatus ? 'active' : '', 'edit-form']">
      <div class="bg-white rounded-2xl p-6 w-full max-w-2xl max-h-screen overflow-y-auto"
           style="box-shadow:0 25px 60px -15px rgba(0,0,0,.22); animation: scaleIn .35s cubic-bezier(.16,1,.3,1) both;">
        <div class="flex items-center justify-between mb-5">
          <h3 class="font-bold text-dark-2 text-lg flex items-center gap-2">
            <span class="w-8 h-8 rounded-lg flex items-center justify-center text-sm" style="background:rgba(59,130,246,.12);color:#3b82f6;">
              <i class="fas fa-pencil-alt"></i>
            </span>
            تعديل الطلب
          </h3>
          <button @click.prevent="toggleEditStatus()"
                  class="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-600 duration-200">
            <i class="fas fa-times text-sm"></i>
          </button>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
          <div class="input"><label>أسم السائق</label><input type="text" placeholder="أسم السائق" v-model="editData.driver_name" class="field" /></div>
          <div class="input"><label class="requier">رقم الهاتف</label><input type="text" placeholder="رقم الهاتف" v-model="editData.driver_phone" class="field" /></div>
          <div class="input"><label class="requier">رقم السيارة</label><input type="text" placeholder="رقم السيارة" v-model="editData.car_no" class="field" /></div>
          <div class="input"><label class="requier">نوع السيارة</label><input type="text" placeholder="نوع السيارة" v-model="editData.car_type" class="field" /></div>
          <div class="input">
            <label class="requier">حجم السيارة</label>
            <select v-model="editData.car_body_type" class="field">
              <option value="" selected disabled>حجم السيارة</option>
              <option value="0">صالون</option><option value="1">بيكم</option>
              <option value="2">فان</option><option value="3">SUV</option>
            </select>
          </div>
          <div class="input"><label class="requier">لون السيارة</label><input type="text" placeholder="لون السيارة" v-model="editData.car_color" class="field" /></div>
          <div class="input"><label class="requier">موديل السيارة</label><input type="text" placeholder="موديل السيارة" v-model="editData.car_model" class="field" /></div>
          <div class="input"><label class="requier">رقم السنوية</label><input type="text" placeholder="رقم السنوية" v-model="editData.sanoia_no" class="field" /></div>
          <div class="input"><label class="requier">رقم الشاصي</label><input type="text" placeholder="رقم الشاصي" v-model="editData.chassis_no" class="field" /></div>
          <div class="input"><label class="requier">عداد السرعة</label><input type="text" placeholder="عداد السرعة" v-model="editData.speedometer" class="field" /></div>
          <div class="input"><label class="requier">السعر</label><input type="text" placeholder="السعر" v-model="editData.price" class="field" /></div>
          <div class="input"><label class="requier">الخصم</label><input type="text" placeholder="الخصم" v-model="editData.discount" class="field" /></div>
        </div>
        <div class="flex justify-end gap-2 mt-5 pt-4 border-t border-gray-100">
          <button class="btn sub-btn text-sm py-2 px-4" @click.prevent="toggleEditStatus()">إلغاء</button>
          <button :class="[postLoader ? 'opacity-60 cursor-not-allowed' : '', 'btn main-btn text-sm py-2 px-4']"
                  :disabled="postLoader" @click="edit_item()">
            <i class="fas fa-save ml-1"></i> حفظ التعديل
          </button>
        </div>
      </div>
    </div>

    <!-- ── Add New Order Card ── -->
    <div v-if="chackOwner || this.getUserRole == 'admin'"
         id="add-form"
         class="w-11/12 mx-auto -mt-6 mb-4 bg-white rounded-2xl overflow-hidden"
         style="box-shadow:0 4px 20px -4px rgba(0,0,0,.1);">

      <!-- Card Header -->
      <div class="px-5 py-3 flex items-center justify-between border-b border-gray-100"
           style="background:linear-gradient(135deg,#f8fafc,#f1f5f9);">
        <div class="flex items-center gap-2">
          <span class="w-7 h-7 rounded-lg flex items-center justify-center text-xs"
                style="background:linear-gradient(135deg,#10b981,#059669);color:#fff;">
            <i class="fas fa-plus"></i>
          </span>
          <span class="font-bold text-dark-2 text-sm">إضافة طلب جديد</span>
        </div>
        <span class="text-xs text-muted">يرجى تعبئة الحقول المطلوبة</span>
      </div>

      <!-- Form Body -->
      <div class="px-5 py-4">
        <form action="" class="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-x-3 gap-y-3">

          <!-- Driver name -->
          <div class="input">
            <label>أسم السائق</label>
            <input type="text" placeholder="أسم السائق" v-model="postData.driver_name" class="field compact-field" />
          </div>

          <!-- Phone -->
          <div class="input">
            <label class="requier">رقم الهاتف</label>
            <input type="text" placeholder="رقم الهاتف" v-model="postData.driver_phone" class="field compact-field" />
          </div>

          <!-- Car no -->
          <div class="input">
            <label class="requier">رقم السيارة</label>
            <input type="text" placeholder="رقم السيارة" v-model="postData.car_no" class="field compact-field" />
          </div>

          <!-- Car type -->
          <div class="input">
            <label class="requier">نوع السيارة</label>
            <input type="text" placeholder="نوع السيارة" v-model="postData.car_type" class="field compact-field" />
          </div>

          <!-- Car body type -->
          <div class="input">
            <label class="requier">حجم السيارة</label>
            <select v-model="postData.car_body_type" class="field compact-field">
              <option value="" selected disabled>الحجم</option>
              <option value="0">صالون</option>
              <option value="1">بيكم</option>
              <option value="2">فان</option>
              <option value="3">SUV</option>
            </select>
          </div>

          <!-- Color -->
          <div class="input">
            <label class="requier">اللون</label>
            <input type="text" placeholder="لون السيارة" v-model="postData.car_color" class="field compact-field" />
          </div>

          <!-- Model -->
          <div class="input">
            <label class="requier">الموديل</label>
            <input type="text" placeholder="موديل السيارة" v-model="postData.car_model" class="field compact-field" />
          </div>

          <!-- Sanoia no -->
          <div class="input">
            <label class="requier">رقم السنوية</label>
            <input type="text" placeholder="رقم السنوية" v-model="postData.sanoia_no" class="field compact-field" />
          </div>

          <!-- Chassis no with search -->
          <div class="input col-span-2 md:col-span-1">
            <label class="requier">رقم الشاصي</label>
            <div class="relative flex">
              <input type="search" placeholder="رقم الشاصي"
                     class="field compact-field rounded-l-none"
                     v-model="postData.chassis_no" />
              <button type="button" @click="filteringChassie()"
                      class="px-3 flex items-center justify-center text-white rounded-r-none rounded-l-xl duration-200"
                      style="background:#3b82f6;border-radius:0 0.75rem 0.75rem 0;">
                <i class="fas fa-search text-xs"></i>
              </button>
            </div>
            <p class="text-xs font-semibold mt-1 text-emerald-600"
               v-if="postData.chassis_no && chassis_filter && chassis_result_count > 0">
              <i class="fas fa-check-circle ml-1"></i> تم فحصها ({{ chassis_result_count }}) مرة
            </p>
            <p class="text-xs font-semibold mt-1 text-red-500"
               v-if="postData.chassis_no && chassis_filter && chassis_result_count === 0">
              <i class="fas fa-info-circle ml-1"></i> لم يتم فحصها سابقاً
            </p>
          </div>

          <!-- Speedometer -->
          <div class="input">
            <label class="requier">عداد السرعة</label>
            <input type="text" placeholder="عداد السرعة" v-model="postData.speedometer" class="field compact-field" />
          </div>

          <!-- Section -->
          <div class="input">
            <label class="requier">قسم الفحص</label>
            <select v-model="postData.status" class="field compact-field">
              <option value="" selected disabled>القسم</option>
              <option value="1">جـــك</option>
              <option value="2">داينو</option>
              <option value="3">فحص البدي</option>
              <option value="6">كمبيوتر</option>
            </select>
          </div>

          <!-- Price -->
          <div class="input">
            <label class="requier">السعر</label>
            <input type="text" placeholder="السعر" v-model="postData.price" class="field compact-field" />
          </div>

          <!-- Discount -->
          <div class="input">
            <label class="requier">الخصم</label>
            <input type="text" placeholder="الخصم" v-model="postData.discount" class="field compact-field" />
          </div>

          <!-- Submit -->
          <div class="col-span-full flex justify-end pt-1">
            <button :class="[postLoader ? 'opacity-60 cursor-not-allowed' : '', 'btn main-btn text-sm py-2 px-5']"
                    :disabled="postLoader" @click.prevent="add_new_item()">
              <i class="fas fa-plus ml-1"></i>
              إضافة الطلب
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- ── Orders List ── -->
    <div class="list-form w-11/12 mx-auto" id="list-form">
      <div class="container">
        <!-- List Header -->
        <div class="section-title border-b border-gray-100 pb-3 mb-3">
          <div class="flex items-center gap-2">
            <span class="w-7 h-7 rounded-lg flex items-center justify-center text-xs"
                  style="background:linear-gradient(135deg,#0f172a,#1e293b);color:#fff;">
              <i class="fas fa-list text-xs"></i>
            </span>
            <span class="font-bold text-dark-2">قائمة الطلبات</span>
          </div>
          <div class="flex items-center gap-2 text-sm text-muted">
            <span>عدد العناصر</span>
            <select v-model="filterData.take" class="bg-surface-2 px-2 py-1 rounded-lg outline-none text-dark-2 text-xs border border-gray-100 cursor-pointer"
                    @change="filtering">
              <option value="2">2</option>
              <option value="15">15</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>
        </div>

        <!-- Filters -->
        <div class="filters">
          <div class="input">
            <input type="search" @change="filtering()" placeholder="🔍 اسم السائق" class="field compact-field" v-model="filterData.name" />
          </div>
          <div class="input">
            <input type="search" @change="filtering()" placeholder="🔍 رقم السنوية" class="field compact-field" v-model="filterData.sanoia_no" />
          </div>
          <div class="input">
            <input type="search" @change="filtering()" placeholder="🔍 رقم الشاصي" class="field compact-field" v-model="filterData.chassis_no" />
          </div>
          <div class="input">
            <select class="field compact-field" @change="filterOrderStatus()" v-model="filterOrderStatusvalue">
              <option value="" selected disabled>حالة الطلب</option>
              <option value="">الكل</option>
              <option :value="5">ملغى</option>
              <option :value="4">مكتمل</option>
            </select>
          </div>
          <div v-if="chackOwner" class="input">
            <select class="field compact-field" @change="filtering()" v-model="filterData.creator_id">
              <option value="" selected disabled>اسم المستخدم</option>
              <option :value="item.id" v-for="item, index in usersList" :key="index">{{ item.name }}</option>
            </select>
          </div>
        </div>

        <!-- Table -->
        <div class="list relative py-3">
          <get-loader v-if="!chassis_result_count && !chassis_filter && !postData.chassis_no"
                      class="absolute inset-0"></get-loader>
          <data-table :fields="fields" :data="orders.data" :actions="chackOwner || this.getUserRole == 'admin'">
            <template v-slot:order_no="{ item }">
              <span class="font-mono text-xs font-bold text-dark-2">{{ item.order_no?.split("-")[4] }}</span>
            </template>
            <template v-slot:created_at="{ item }">
              <span class="text-xs text-muted">{{ getFormDate(item.created_at) }}</span>
            </template>
            <template v-slot:status="{ item }">
              <span :class="orderStatus(item.status).cla"
                    class="px-2.5 py-1 rounded-lg text-xs font-semibold inline-block">
                {{ orderStatus(item.status).text }}
              </span>
            </template>
            <template v-slot:updated_at="{ item }">
              <span class="text-xs text-muted">{{ getFormDate(item.updated_at) }}</span>
            </template>
            <template v-slot:actions="{ item }">
              <ul class="actions-list">
                <li @click="showChangeStatus(item)" aria-label="نقل الى قسم"
                    class="hover:text-purple-500 hover:border-purple-200 hint--top">
                  <i class="fas fa-bezier-curve"></i>
                </li>
                <li @click="add_img_form(item.id)" aria-label="اضافة صور"
                    class="hover:text-blue-500 hover:border-blue-200 hint--top">
                  <i class="fas fa-file-image"></i>
                </li>
                <li aria-label="طباعة فاتورة" v-if="item.is_completed == 1"
                    class="hover:text-emerald-500 hover:border-emerald-200 hint--top">
                  <router-link :to="'/print/' + item.id">
                    <i class="fas fa-print"></i>
                  </router-link>
                </li>
                <li v-if="item.status !== 4 && item.status !== 5 && (chackOwner || chackAdmin)"
                    aria-label="تعديل الطلب" class="hover:text-blue-500 hover:border-blue-200 hint--top"
                    @click="editInit(item)">
                  <i class="fas fa-pencil-alt"></i>
                </li>
                <li v-if="item.status !== 4 && item.status !== 5 && (chackOwner || chackAdmin)"
                    aria-label="أكمال الطلب" class="hover:text-emerald-500 hover:border-emerald-200 hint--top"
                    @click="complete_order(item)">
                  <i class="fas fa-clipboard-check"></i>
                </li>
                <li v-if="item.status !== 4 && item.is_completed == 0 && item.status !== 5 && (chackOwner || chackAdmin)"
                    aria-label="الغاء الطلب" class="hover:text-red-500 hover:border-red-200 hint--top"
                    @click="cancele_order(item)">
                  <i class="fas fa-times"></i>
                </li>
              </ul>
            </template>
          </data-table>
        </div>
      </div>
    </div>

    <!-- ── Pagination ── -->
    <div class="w-11/12 mx-auto py-4 bg-white rounded-2xl mt-3 shadow-card"
         v-if="orders.total > filterData.take">
      <div class="container flex items-center justify-center">
        <v-pagination v-model="currentPage" :records="orders.total" :per-page="filterData.take" />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Compact field height */
.compact-field {
  padding-top: 0.45rem !important;
  padding-bottom: 0.45rem !important;
  font-size: 0.8rem !important;
}
</style>

<script>
import $http from "@/plugins/axios.js"
export default {
  data() {
    return {
      currentPage: 1,
      changeStatusInit: false,
      filterOrderStatusvalue: "",
      carTypes: ["Kia", "Hunday", "Tayouta"],
      postData: {
        driver_name: "",
        driver_phone: "",
        car_no: "",
        car_type: "",
        car_color: "",
        car_body_type: "",
        car_model: "",
        sanoia_no: "",
        chassis_no: "",
        speedometer: "",
        price: "",
        discount: 0,
        status: "",
      },
      usersList:[],
      changeStatusValue: { status: "" },
      editData: {},
      tempData: {},
      filterData: {
        take: 15,
        page: 1,
        name: "",
        chassis_no: "",
        sanoia_no: "",
        creator_id: "",
      },
      chassis_filter: false,
      chassis_result_count: 0
    };
  },
  computed: {
    fields() {
      return [
        { title: "رقم الفاتورة", key: "order_no" },
        { title: "تاريخ",        key: "created_at" },
        { title: "أسم السائق",   key: "driver_name" },
        { title: "نوع السيارة",  key: "car_type" },
        { title: "لون السيارة",  key: "car_color" },
        { title: "السعر",        key: "price" },
        { title: "خصم",          key: "discount" },
        { title: "السعر الكلي",  key: "total_price" },
        { title: "حالة الطلب",   key: "status" },
        { title: "أخر تعديل",    key: "updated_at" },
      ];
    },
    chackOwner() { return this.getUserRole == "Owner"; },
    chackAdmin()  { return this.getUserRole == "admin"; },
  },
  watch: {
    currentPage(value) {
      this.filterData.page = value;
      this.getDayleOrders(this.filterData);
    },
  },
  methods: {
    filtering()          { this.getDayleOrders(this.filterData); },
    filteringChassie()   {
      $http.get(`/order?filter[chassis_no]=${this.postData.chassis_no}&take=1000`).then((res) => {
        this.chassis_result_count = res.data.total;
        this.chassis_filter = true;
      });
    },
    filterOrderStatus() {
      if      (this.filterOrderStatusvalue == "")  this.getOrders();
      else if (this.filterOrderStatusvalue == 4)   this.getCompletedOrders();
      else                                          this.getCancelleddOrders();
    },
    add_new_item() {
      this.createOrder(this.postData).then(() => {
        this.postData = { driver_name:"", driver_phone:"", car_no:"", car_type:"", car_body_type:"", car_color:"", car_model:"", sanoia_no:"", chassis_no:"", speedometer:"", price:"", discount:0, status:'' };
      });
    },
    editInit(item) {
      this.toggleEditStatus();
      Object.assign(this.editData, item);
      this.editData._method = "PUT";
    },
    edit_item() {
      delete this.editData.last_login;
      this.updateOrder(this.editData).then(() => { this.toggleEditStatus(); });
    },
    add_img_form(id)     { this.$router.push(`/order_image/${id}`); },
    cancele_order(item)  { this.confirmDelete(() => { this.canceleOrder(item.id); }); },
    complete_order(item) { this.confirmComplete(() => { this.completeOrder(item.id); }); },
    showChangeStatus(item) {
      this.changeStatusInit = true;
      this.changeStatusValue.order_id = item.id;
    },
    changeStatusData() {
      this.changeStatusOrder({
        order_id: this.changeStatusValue.order_id,
        data: this.dataReutrn({ status: this.changeStatusValue.status, _method: "PUT" }),
      }).then(() => {
        this.changeStatusInit = false;
        this.getDayleOrders();
      });
    },
  },
  mounted() {
    if (this.chackOwner) {
      this.getUsers().then(() => { this.usersList = this.users.data; });
    }
    this.getDayleOrders();
    document.querySelectorAll("#OrderPage .field").forEach((el) => {
      el.addEventListener("input", () => {
        el.value.length !== 0 ? el.classList.add("filled") : el.classList.remove("filled");
      });
    });
  },
};
</script>
